import { render, staticRenderFns } from "./DeviationsQTStatistics.vue?vue&type=template&id=a8910266&"
import script from "./DeviationsQTStatistics.vue?vue&type=script&lang=js&"
export * from "./DeviationsQTStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports